/**
 * Canonical default character limits for user-editable text inputs.
 * These are the bundled client defaults and the server fallback when the
 * AppConfig `text-input-limits` row is absent. Admins can override per-key
 * via AppConfig without a redeploy.
 */
export const TEXT_INPUT_LIMITS = {
    memoryNote: 500,
    dismissReason: 280,
    dealNote: 2000,
    dealTimelineNote: 2000,
    contactNote: 2000,
    clientNote: 500,
    actionItem: 200,
    chatMessage: 30000,
    emailBody: 30000,
    editorAiInstruction: 2000,
};
